import React from 'react'
import "./../Footer/Footer.css"
function Footer() {
  const year = new Date().getFullYear()
  return (
    <div className='blue_div_footer_end'>
      <div className='d-flex justify-content-center'>
        <p className='para_footer_end'>{`© Copyright ${year} 360 SynergyTech. All rights reserved.`}</p>
      </div>
    </div>
  )
}

export default Footer
